import { render } from "./ModalQueroSerCliente.vue?vue&type=template&id=20b5619a&scoped=true"
import script from "./ModalQueroSerCliente.vue?vue&type=script&lang=js"
export * from "./ModalQueroSerCliente.vue?vue&type=script&lang=js"

import "./ModalQueroSerCliente.vue?vue&type=style&index=0&id=20b5619a&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b5619a"]])

export default __exports__